import Vue from 'vue';
import App from './App.vue';
import Store from './store/store';
import VueRouter from 'vue-router';
import { routes } from './routes';
import './components'
import executeInterceptor from './service/HttpHelper';

import BootstrapVue from 'bootstrap-vue';
import VModal from 'vue-js-modal';
import VueHtmlToPaper from 'vue-html-to-paper';
import vClickOutside from 'v-click-outside'
import moment from 'moment';
import mask from 'awesome-mask';
import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VModal);
Vue.use(vClickOutside)
Vue.directive("mask", mask);

const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
		'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
		`/static/css/service-order-view.css?date=${Date.now()}}`
	]
};

Vue.use(VueHtmlToPaper, options);

moment.locale('pt-br');

executeInterceptor();

const router = new VueRouter({
  linkActiveClass: "active",
  routes: routes,
  mode: "history" //serve para tirar o hash da barra de endereco do navegador
});

new Vue({
  el: '#app',
  router: router,
  store: Store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js